import React, { Fragment } from 'react';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Page from '@components/Page';
import { css } from '@emotion/react';
import { getPageElements } from '@lib/utils';
import { graphql } from 'gatsby';

export default function GenericTemplate({
  data: { page },
  pageContext: { language, refs, layouts }
}) {
  const { body } = getPageElements(page);
  return (
    <Page>
      <Header
        dark
        language={language}
        refs={refs}
        layouts={layouts}
      />
      <div
        className="py-5"
        css={css`
          h2,
          h3,
          h4 {
            margin-top: 1em;
          }
        `}
        dangerouslySetInnerHTML={{ __html: body }}
      >
      </div>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Page>
  );
}

export const query = graphql`
  query($id: Int) {
    page: wordpressWpWebsites(wordpress_id: { eq: $id }) {
      ...Page
    }
  }
`;